import http from "@/utils/request"

export default {
	plan: {
		list: async function (data = {}) {
			return await http.get("plan/list", data);
		},
		add: async function (data = {}) {
			return await http.post("plan/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("plan/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("plan/del", data);
		},
		info: async function (data = {}) {
			return await http.get("plan/info", data);
		},
		option: async function (data = {}) {
			return await http.get("plan/option", data);
		},
		trial: async function (data = {}) {
			return await http.get("plan/trial", data);
		},
	},
	times: {
		list: async function (data = {}) {
			return await http.get("times/list", data);
		},
		add: async function (data = {}) {
			return await http.post("times/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("times/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("times/del", data);
		},
		info: async function (data = {}) {
			return await http.get("times/info", data);
		},
		option: async function (data = {}) {
			return await http.get("times/option", data);
		},
	},
	money: {
		list: async function (data = {}) {
			return await http.get("money/list", data);
		},
		add: async function (data = {}) {
			return await http.post("money/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("money/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("money/del", data);
		},
		info: async function (data = {}) {
			return await http.get("money/info", data);
		},
		option: async function (data = {}) {
			return await http.get("money/option", data);
		},
	},
	project: {
		list: async function (data = {}) {
			return await http.get("project/list", data);
		},
		add: async function (data = {}) {
			return await http.post("project/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("project/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("project/del", data);
		},
	}
}
